<template>
  <div class="text-area" :class="{portrait: portrait}">
    <div v-if="artist">
      <div class="like-h3">
        <like-box :imageId="image.image_id" />
        <h3><ix-router-link :to="'/artists/' + artist.portfolio_url">{{ artist.formatted_name }}</ix-router-link></h3>
      </div>
      <div class="img-desc">
        {{ image.detail.title }}
      </div>

      <div class="img-details">
        <div v-if="image.detail.medium">
          {{ $nippets.portfolio.medium }}: {{ image.detail.medium}}
        </div>
        <div v-if="image.detail.client">
          {{ $nippets.portfolio.client }}: {{ image.detail.client}}
        </div>
        <div>
          {{ $k.spacesAfterCommas(image.detail.description)}}
        </div>
      </div>
      <div class="social-panel">
        <social-panel :url="url" :media="media" :message="message" :caption="artist.formatted_name" />
      </div>
      <div class="tag-panel">
        <gallery-tag v-for="gallery in image.galleries" :key="gallery" :url="gallery" />
        <div class="tag region" v-on:click.stop="changeRegion(artist.region)">{{ artist.region }}</div>
      </div>
    </div>
    <div class="mobile-only">
      <div class="font-med">{{ $nippets.portfolio.wantToDiscuss }}</div>
      <div class="bot-panel">
        <email-and-call :artist="artist" />
      </div>
    </div>
  </div>
</template>

<script>
import EmailAndCall from '@/components/panels/EmailAndCall.vue'
import LikeBox from '@/components/buttons/LikeBox.vue'
import GalleryTag from '@/components/buttons/GalleryTag.vue'
import SocialPanel from '@/components/panels/SocialPanel.vue'
export default {
  components: {
    EmailAndCall,
    LikeBox,
    GalleryTag,
    SocialPanel
  },
  props:{
    artist: Object,
    image: Object
  },
  data () {
    return {
      portrait: false
    }
  },
  mounted () {
    this.portrait = (window.innerWidth < window.innerHeight)
  },
  computed: {
    message: function () {
      if(this.image && this.artist) {
        if(this.image.detail.description) return this.image.detail.description
        return this.artist.formatted_name
      }
      return ''
    },
    media: function () {
      if(this.image && this.image.url){
        return this.$k.getImage500(this.image.url)
      }
      return ''
    },
    url: function () {
      if(this.image && this.image.url){
        return this.$k.getImagePermalink(this.image, this.artist)
      }
      return ''
    }
  },
  methods: {
    changeRegion: function (region) {
      this.$store.dispatch('goRegion', region)
    }
  }
}
</script>

<style scoped>
h3{
  font-size:28px;
  font-weight:500;
  margin:10px 0 4px 0;
}

h3 a{
  text-decoration: none;
  color:#000;
}

h3 a:hover{
  color:#ce0e2d;
}

.social-panel{
  margin-top: 50px;
  margin-bottom: 16px;
}

.bot-panel{
  padding:10px 0 30px 0;
}

.img-desc{
  font-size:21px;
  overflow-wrap: break-word;
}

.img-details{
  font-size:17px;
  color:#6d6d64;
}

.img-details div{
  margin:5px 0;
  overflow-wrap: break-word;
}

.text-area{
  width:20vw;
  margin-left:20px;
  box-sizing:border-box;
  display:flex;
  flex-direction: column;
  justify-content: space-between;
}

.text-area.portrait{
  margin-left:0;
}

@media screen and (max-width:960px){
  .text-area{
    flex-direction:row;
    width:100%;
    box-sizing:border-box;
  }

  .mobile-only{
    display:none;
  }

  .like-h3{
    display:flex;
    padding-top:16px;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
}
</style>
